import { render, staticRenderFns } from "./StockExpired.vue?vue&type=template&id=0f782870&"
import script from "./StockExpired.vue?vue&type=script&lang=js&"
export * from "./StockExpired.vue?vue&type=script&lang=js&"
import style0 from "./StockExpired.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports